import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import type React from 'react';
import { useContext } from 'react';
import { LINK_INFO_DOWNLOADABLE, SHARED_LINK_INFO_ACTIONS } from 'src/constants';
import { BaseActionPermsMenu } from 'src/HomePage/DrawerAndPushedContents/PushedContents/AkomiMediaCardGrid/AkomiMediaCard/MediaCardActionsIcon/ActionPermsMenu';
import type { ActionOption } from 'src/HomePage/DrawerAndPushedContents/PushedContents/AkomiMediaCardGrid/types';
import viewStateVar from 'src/store/viewState';
import { SharedLinkContext } from './context';

interface StylesClasses {
  cardMoreActionsButton: string;
  popper: string;
  button: string;
  iconLabel: string;
}

const useStyles = makeStyles<Theme, object, keyof StylesClasses>((theme) => ({
  cardMoreActionsButton: {
    zIndex: 1,
    position: 'absolute',
    cursor: 'pointer',
    '& svg': {
      color: theme.palette.text.primary,
      padding: '2px',
      backgroundColor: theme.palette.background.default,
      borderRadius: '4px',
    },
  },
  popper: {
    zIndex: 1000,
  },
  button: {
    minWidth: 'auto',
  },
  iconLabel: {
    display: 'flex',
    padding: '2px 0 2px 10px',
  },
}));

interface SharedLinkActionsPermsProps {
  itemId: string;
}

const SharedLinkActionsPerms = ({ itemId }: SharedLinkActionsPermsProps): React.JSX.Element => {
  const { linkInfo } = useContext(SharedLinkContext);

  const onDownload = (): void => {
    // Open the download modal to let user select format
    viewStateVar({
      ...viewStateVar(),
      sharedItemDownloadDialog: itemId,
    });
  };

  const classes = useStyles();

  const actions = linkInfo.downloadable ? SHARED_LINK_INFO_ACTIONS[LINK_INFO_DOWNLOADABLE] : [];

  const handleMenuItemClick = (option: ActionOption): void => {
    if (option.slug === LINK_INFO_DOWNLOADABLE) {
      onDownload();
    }
  };

  return <BaseActionPermsMenu actions={actions} handleMenuItemClick={handleMenuItemClick} classes={classes} />;
};

export default SharedLinkActionsPerms;
